import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { ReactNode } from 'react';

import Searcher from 'src/common/components/Searcher';
import Sorter from 'src/common/components/Sorter';
import { EOrder } from 'src/interfaces/Order';

interface Props {
  onSearchChange: (query: string) => void;
  order: EOrder;
  orderByKey: string;
  searchPlaceholder?: string;
  searchQuery: string;
  setOrder: (order: EOrder) => void;
  setOrderByKey: (key: string) => void;
  /** When false, omit the Searcher (e.g. search lives in the toolbar). Default true. */
  showSearch?: boolean;
  sortLabel?: string;
  sortOptions: { label: string; value: string }[];
  /** Rendered directly under the search field (e.g. user Autocomplete). */
  belowSearch?: ReactNode;
  children?: ReactNode;
}

const FiltersPopoverSearchSort = ({
  belowSearch,
  children,
  onSearchChange,
  order,
  orderByKey,
  searchPlaceholder,
  searchQuery,
  setOrder,
  setOrderByKey,
  showSearch = true,
  sortLabel,
  sortOptions,
}: Props) => (
  <>
    <Grid container spacing={2} sx={{ p: 2, pb: children ? 1 : 2 }}>
      {showSearch ? (
        <Grid size={12}>
          <Searcher
            expanded
            onChange={onSearchChange}
            query={searchQuery}
            width="100%"
            openWidth="100%"
            placeholder={searchPlaceholder}
          />
        </Grid>
      ) : null}
      {belowSearch ? <Grid size={12}>{belowSearch}</Grid> : null}
      <Grid size={12}>
        <Sorter
          label={sortLabel}
          order={order}
          orderByKey={orderByKey}
          setOrder={setOrder}
          setOrderByKey={setOrderByKey}
          sortOptions={sortOptions}
        />
      </Grid>
    </Grid>
    {children ? (
      <>
        <Divider />
        {children}
      </>
    ) : null}
  </>
);

export default FiltersPopoverSearchSort;
